<template>
  <hi-dialog width="600px" v-model="open">
    <hi-form-hive-standard :submit-fn="submit" @successful="open = false">
      <mfc-input-account form-key="accountId" />
    </hi-form-hive-standard>
  </hi-dialog>
</template>

<script>
import HiDialog from "@/hive-vue3/components/dialogs/HiDialog";
import HiFormHiveStandard from "@/hive-vue3/components/form/HiFormHiveStandard";
import { ref } from "vue";
import MfcInputAccount from "@/hive-vue3/modules/accounts/controls/MfcInputAccount";
import { updateLeadById } from "@/hive-vue3/modules/leads/data";
import { leadsState } from "@/hive-vue3/modules/leads/state";
import {
  addNewHistory,
  DefaultHistoryData,
  historyActions,
} from "@/hive-vue3/modules/history/data";
import { getAccountNameEmailById } from "@/hive-vue3/modules/accounts/data";
export default {
  name: "LeadsLinkAccountDialog",
  components: { MfcInputAccount, HiFormHiveStandard, HiDialog },
  setup() {
    const open = ref();
    async function submit(formData) {
      try {
        const historyObj = new DefaultHistoryData();
        historyObj.action = historyActions.LINK;
        historyObj.target = "leads";
        historyObj.targetId = leadsState.currentLeadId;
        historyObj.comments = `Link account ${getAccountNameEmailById(
          formData.accountId
        )}`;

        await addNewHistory(historyObj);

        await updateLeadById(leadsState.currentLeadId, formData);
        return { successful: true };
      } catch (e) {
        return { successful: false, errorMsg: e };
      }
    }
    return {
      open,
      submit,
    };
  },
};
</script>

<style scoped></style>
